export const TRANSLATED_FROM_ID = 'hs_translated_from_id';
export const TRANSLATIONS_ASSOCIATION_NAME = 'OBJECT_TO_TRANSLATIONS';